import * as React from 'react';

const Svg5ADay: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.4 6C5.7 6 3 7.967 3 11.9 3 17.575 6.6 22 9.3 22c1.8 0 1.8-.983 2.7-.983.9 0 .9.983 2.7.983 2.7 0 6.3-3.934 6.3-10.1C21 7.967 18.3 6 15.6 6s-2.7.983-3.6.983c-.9 0-.9-.983-3.6-.983z"
        fill="currentColor"
      />
      <path d="M9 3c2.5 1 3 2 3 5" stroke="currentcolor" strokeWidth={2} />
      <path
        d="M17.14 2.075s-.313 2.167-1.808 3.155c-1.495.987-3.611.444-3.611.444s.312-2.167 1.807-3.154c1.495-.988 3.611-.445 3.611-.445z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Svg5ADay;
